<template>
  <v-container class="pa-2">
    <v-row class="v-flex flex-row mt-6 mb-10">
      <v-col lg="4" v-for="(item, idx) in references" :key="idx">
        <InfoCard :cardData="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InfoCard from "../components/Shared/InfoCard";
import { db } from "@/main";

export default {
  components: {
    InfoCard
  },
  data() {
    return {
      references: []
    };
  },
  firestore() {
    return { references: db.collection("References") };
  }
};
</script>

<style scoped>
</style>